module.exports = __webpack_public_path__ + "img/ico_article--white.34daeb1d.svg";